"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webix_jet_1 = require("webix-jet");
const globals_1 = require("../models/globals");
class RechercheProduit extends webix_jet_1.JetView {
    config() {
        return {
            view: "popup",
            width: 300,
            hidden: true,
            resize: true,
            body: {
                view: "form",
                elements: [{
                        view: "search",
                        id: "produitSearchFieldId"
                    }, {
                        view: "list",
                        id: "produitSearchListId",
                        url: globals_1.phpPath + "articles.php?option=shortList",
                        template: "#codeArticle# - #designation#",
                        height: 350,
                        select: true
                    }
                ]
            }
        };
    }
    init() {
        this.sf = this.$$("produitSearchFieldId");
        this.sl = this.$$("produitSearchListId");
    }
    filtre(obj, value) {
        let combi = obj.designation + obj.codeArticle;
        let oNom = combi.toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        return oNom.toLowerCase().indexOf(value) != -1;
    }
    exit(item) {
        this.sf.setValue("");
        this.sl.filter(function (obj) { return (true); });
        if (item) {
            globals_1.lv2.trace(item.codeArticle);
            // @ts-ignore
            this.app.callEvent("code:produit:choisi", [item]);
        }
        // @ts-ignore
        this.getRoot().hide();
    }
    ready() {
        let me = this;
        this.sf.attachEvent("onTimedKeyPress", function () {
            let value = this.getValue().toLowerCase();
            me.sl.filter(function (obj) { return (me.filtre(obj, value)); });
        });
        this.sl.attachEvent("onEnter", function () {
            let id = me.sl.getSelectedId(false);
            if (id) {
                let item = this.getItem(id);
                me.exit(item);
            }
        });
        this.sl.attachEvent("onItemDblClick", function (id, e, node) {
            let item = this.getItem(id);
            me.exit(item);
        });
    }
    showPopup(elem, code) {
        // @ts-ignore
        this.getRoot().show(elem);
        this.sf.focus();
        this.sf.setValue(code);
    }
}
exports.default = RechercheProduit;
